import { composeClassNames } from "@faedev/editor-utils";
import MuxPlayer from "@mux/mux-player-react";
import constants from "src/constants";
import { sVideo } from "src/styles/sVideo.module.scss";

type Props = {
  className?: (string | string) | null | undefined;
  data: any;
};

function VideoStream({ className, data }: Props) {
  return (
    <div className={composeClassNames([sVideo, className, "video-wrapper"])}>
      <MuxPlayer
        envKey={constants.MuxDataEnvKey}
        streamType="live"
        playbackId={data.video?.mux?.playback_id}
        metadata={{
          video_id: `${data.content_type}-id-${data.video.id}`,
          video_title: data.video.title,
        }}
        autoPlay
        muted
      />
    </div>
  );
}

export default VideoStream;
